import React, { useEffect, useState } from "react";
import { Button, Typography, Input, message, Form, Select } from "antd";
// import { commentsSVC, authSVC } from "../../services";
import CommentsDataTable from "../../components/dataTable/b2b/CommentasDataTable";
import axios from "axios";
import * as Cookie from "universal-cookie";
import useSWR from "swr";
const { Text } = Typography;

const cookie = new Cookie.default();
const cachedToken = cookie.get("userAuthTokenAdmin");

interface Contentdata {
  key?: string;
  _id: string;
  bodyText: string;
  user_id: string;
  video_id: string;
}
const fetcher = (url: any) =>
  axios
    .get(url, {
      headers: {
        Authorization: `Bearer ${cachedToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => res?.data?.data);

const HIDDEN_CLIENT_EMAILS = [
  "udhaya+500@soulstudio.world",
  "udhaya+501@soulstudio.world",
  "udhaya+5001@soulstudio.world",
];

function Clients() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL;

  const { data: rawContentData, mutate: refreshClients } = useSWR(
    API_URL + "/admin/getAllAdmin/",
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  const contentData = rawContentData?.filter(
    (item: any) => !HIDDEN_CLIENT_EMAILS.includes(item.email)
  );

  useEffect(() => {
    console.log(contentData, "contentData");
  }, [contentData]);

  return (
    <div className="contentBox">
      <div className="info sub_title">
        <Text className="title24">Clients</Text>
        <p>Assign Membership Plan</p>
      </div>
      <CommentsDataTable
        // deleteComments={deleteComments}
        setshowModel={setIsModalOpen}
        isOpen={isModalOpen}
        contentData={contentData}
        refreshClients={refreshClients}
      />
    </div>
  );
}

export default Clients;
